module.exports = __webpack_public_path__ + "media/entities/6006-4d959d86.png";